var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.fakturList!==undefined && _vm.fakturList.length>1)?_c('span',[_c('ol',_vm._l((_vm.fakturList),function(item,idx){return _c('li',[_vm._v(_vm._s(item)+" ")])}),0)]):(_vm.fakturList!==undefined && _vm.fakturList.length==1)?_c('span',[_vm._v(" "+_vm._s(_vm.fakturList[0]))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }